import React from 'react';

function LogOutIcon({ className, width = undefined, height = undefined }) {
    return (
        <svg className={'icon logout-icon ' + className} width={width} height={height} viewBox="0 0 16 16">
            <path
                fillRule="evenodd"
                d="M4.3 6c.387 0 .7.313.7.7 0 .354-.263.647-.605.694L4.3 7.4H2.5c-.567 0-1.034.429-1.094.98L1.4 8.5v5c0 .567.429 1.034.98 1.094l.12.006h11c.567 0 1.034-.429 1.094-.98l.006-.12v-5c0-.567-.429-1.034-.98-1.094L13.5 7.4h-1.8c-.387 0-.7-.313-.7-.7 0-.354.263-.647.604-.694L11.7 6H13.5c1.325 0 2.41 1.032 2.495 2.336L16 8.5v5c0 1.325-1.032 2.41-2.336 2.495L13.5 16h-11C1.175 16 .09 14.968.005 13.664L0 13.5v-5c0-1.325 1.032-2.41 2.336-2.495L2.5 6h1.8zM8.446.147L8.53.22l3.002 3.001c.293.293.293.768 0 1.06-.266.267-.683.291-.977.074l-.084-.073L8.75 2.56v9.69c0 .414-.336.75-.75.75s-.75-.336-.75-.75V2.56L5.535 4.276c-.266.266-.683.29-.976.072l-.085-.072c-.266-.267-.29-.683-.072-.977l.072-.084L7.47.22c.266-.267.683-.29.976-.073z"
            />
        </svg>
    );
}

export default LogOutIcon;
